export var AlertCategory;
(function (AlertCategory) {
    AlertCategory["Damages"] = "damages";
    AlertCategory["Frauds"] = "frauds";
    AlertCategory["Quality"] = "quality";
    AlertCategory["VLC"] = "vlc";
    AlertCategory["RT"] = "rt";
})(AlertCategory || (AlertCategory = {}));
